<script setup lang="ts">
import type { PropType } from 'vue'
import type { ObjectSearchType } from './../model/types'
import './assets/style.scss'

defineProps({
  list: {
    type: Array as PropType<ObjectSearchType[]>,
    required: true,
  },
  withSearch: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['selected', 'open_select'])

/**
 * Функция обработчик клика
 * @param item
 * @param event
 */
const clickHandler = (item: ObjectSearchType, event: MouseEvent) => {
  if (event.metaKey || event.ctrlKey || event.button === 1) {
    emits('open_select', item)
  } else {
    emits('selected', item)
  }
}

/** Определение слотов */
defineSlots<{
  search_field: (props: {}) => any
}>()
</script>

<template>
  <div class="object-search__result" v-if="list.length || withSearch">
    <div
      v-if="withSearch"
      class="object-search__field"
      :class="{ 'object-search__field_margin': list.length }"
    >
      <slot name="search_field" />
    </div>

    <div
      v-for="item in list"
      :key="item.id"
      class="object-search__item"
      @click="(event) => clickHandler(item, event)"
      @mousedown="(event) => clickHandler(item, event)"
    >
      {{ item.name }}

      <div class="object-search__parents">
        {{ item.parents_name || $t('itf.root') }}
      </div>
    </div>
  </div>
</template>
